<template>
  <!-----------------MAIN CONTAINER----------------------------------------------->
  <v-container>
    <!-----------------SEARCH BAR------------------------------------------------->
    <v-card-title v-if="!failed">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        clearable
      ></v-text-field>
    </v-card-title>
    <!---------------------------------------------------------------------------->

    <!----------------------EDIT, ADD NEW BRAND FORM------------------------------->

    <!---------BRANDS DATA TABLE------------------------------------------------->
    <v-data-table
      :headers="headers"
      :items="finalBrands"
      :search="search"
      class="elevation-1"
      v-if="!failed"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>SEASONS</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn color="success" outlined @click="addNewBrand" class="mx-2"
            ><v-icon> mdi-plus-circle-outline </v-icon> Add a Season</v-btn
          >

          <!---------DIALOG DELETE BRAND------------------------------------------------->
          <v-dialog v-model="dialogDelete" width="unset">
            <v-card>
              <v-card-title class="headline"
                >Are you sure you want to delete Season
                {{ selecetdBrand }}?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" outlined @click="closeDelete"
                  >Cancel</v-btn
                >
                <v-btn color="success" outlined @click="deleteItemConfirm"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!----------------------------------------------------------------------------->
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editBrand(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
    <!---------------------------------------------------------------------------->

    <!---------------------------------------------------------------------------->

    <!---------------------------------------------------------------------------->

    <!----------------------RED SNACKBAR------------------------------------------>
    <v-snackbar
      top
      v-model="snackbar"
      color="#FF3232"
      class="white--text"
      width="800"
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <!---------------------------------------------------------------------------->

    <!------STATUS COMPONENT IF SERVER IS COMPLETELY DOWN-------------------------->
    <status-info
      v-if="failed && filename !== ''"
      :responseMessage="responseMessage"
      :filename="filename"
      @close="closeStatuDialog"
    >
    </status-info>
    <!---------------------------------------------------------------------------->
    <WHSeasonForm
      v-if="showBrandForm"
      :isUpdate="isUpdate"
      :close="closeModal"
      :DoesCreated="DoesCreated"
      :Brand="brand"
    ></WHSeasonForm>
    <!-----------------STATUS DIALOG, WHEN DOING STUFF WITH BRANDS---------------->
    <v-dialog persistent v-model="statusDialog" width="unset">
      <status-info
        :responseMessage="responseMessage"
        :filename="filename"
        :pending="pending"
        @close="closeStatuDialog"
      ></status-info>
    </v-dialog>
    <!---------------------------------------------------------------------------------->
  </v-container>
  <!------------------------------------------------------------------------------->
</template>

<script>
import axios from "axios";
import StatusInfo from "../organisms/StatusInfo";
import WHSeasonForm from "../modals/WHSeasons.vue";

export default {
  name: "WHSeasons",
  components: {
    StatusInfo,
    WHSeasonForm,
  },
  data: () => ({
    valid: true,
    search: "",
    dialogDelete: false,
    dialogDeleteRRP: false,
    snackbar: false,
    snackbarSuccess: false,
    snackbarText: "",
    snackbarSuccessText: "",
    finalBrands: [],
    headers: [
      { text: "Title", value: "name" },
      { text: "SKU Code", value: "SKU_Code" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    rules: {
      required: (value) => !!value || "Field is required.",
    },
    brands: [],
    selecetdBrand: "",
    editedItem: {},
    responseMessage: "",
    filename: "",
    failed: false,
    statusDialog: false,
    pending: false,

    showBrandForm: false,
    brand: undefined,
    formTitle: "",
    isUpdate: false,
  }),
  mounted() {
    this.getData();
  },
  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  computed: {},
  methods: {
    editBrand(item) {
      this.brand = item;
      this.isUpdate = true;
      this.formTitle = `Edit brand ${item.brandName}`;
      this.showBrandForm = true;
    },
    addNewBrand() {
      this.brand = {};
      this.formTitle = `Add brand`;
      this.showBrandForm = true;
    },
    closeBrandForm(changed) {
      this.showBrandForm = false;
      //if brands changed
      if (changed) {
        this.getData();
      }
    },
    closeModal() {
      this.showBrandForm = false;
      this.isUpdate = false
    },
    DoesCreated() {
      this.getData();
    },
    async getData() {
      this.$store
        .dispatch("getSeasonsWH")
        .then((result) => {
          console.log(result.data);
          this.brands = result.data;
          this.finalBrands = result.data;
        })
        .catch((error) => {
          console.log(error);
          switch (error.response.status) {
            case 400:
              this.filename = "empty.svg";
              this.failed = true;
              this.responseMessage =
                "Sorry, something went wrong, please contact TECH team!";
              break;
            case 401:
              //clear local storage, push to login
              localStorage.clear();
              this.$router.push("login");
              break;
            case 403:
              this.filename = "403_forbidden.svg";
              this.failed = true;
              this.responseMessage =
                "Sorry, you are forbidden to do this action!";
              break;
            case 500:
              this.filename = "server_down.svg";
              this.failed = true;
              this.responseMessage =
                "Internal server error, please contact TECH team!";
          }
        });
    },
    //CHECK IF ARRAYS ARE EQUAL
    checkArrays(array1, array2) {
      const arraysEqual = (a1, a2) =>
        a1.length === a2.length &&
        a1.every((o, idx) => objectsEqual(o, a2[idx]));

      const objectsEqual = (o1, o2) =>
        typeof o1 === "object" && Object.keys(o1).length > 0
          ? Object.keys(o1).length === Object.keys(o2).length &&
            Object.keys(o1).every((p) => objectsEqual(o1[p], o2[p]))
          : o1 === o2;
      return arraysEqual(array1, array2);
    },

    deleteItem(item) {
      this.editedIndex = this.finalBrands.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
      this.selecetdBrand = item.name;
    },

    deleteItemConfirm() {
      this.pending = true;
      this.statusDialog = true;
      this.dialogDelete = false;
      //deleting brand
      let brandName = this.editedItem.name;
      axios
        .delete("api/WHSeason/" + this.editedItem.id)
        .then(() => {
          this.filename = "high_five.svg";
          this.pending = false;
          this.dialogDelete = false;
          this.responseMessage = "Success! Season " + brandName + " deleted!";
        })
        .catch((error) => {
          switch (error.response.status) {
            case 400:
              this.filename = "empty.svg";
              this.pending = false;
              this.responseMessage =
                "Sorry, something went wrong, please contact TECH team!";
              break;
            case 401:
              //clear local storage, push to login
              localStorage.clear();
              this.$router.push("login");
              break;
            case 403:
              this.filename = "403_forbidden.svg";
              this.pending = false;
              this.responseMessage =
                "Sorry, you are forbidden to do this action!";
              break;
            case 500:
              this.filename = "server_down.svg";
              this.pending = false;
              this.responseMessage =
                "Internal server error, please contact TECH team!";
          }
        });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.brandStories = [""];
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeStatuDialog() {
      this.getData();
      this.statusDialog = false;
    },
  },
};
</script>
